import { render, staticRenderFns } from "./ClearTagEdit.vue?vue&type=template&id=2a738d2f&scoped=true"
import script from "./ClearTagEdit.vue?vue&type=script&lang=js"
export * from "./ClearTagEdit.vue?vue&type=script&lang=js"
import style0 from "./ClearTagEdit.vue?vue&type=style&index=0&id=2a738d2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a738d2f",
  null
  
)

export default component.exports